/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Select_PlaceholderInputs */

const es_cap_select_placeholder = /** @type {(inputs: Cap_Select_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona una titulación`)
};

const gl_cap_select_placeholder = /** @type {(inputs: Cap_Select_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona unha titulación`)
};

const en_cap_select_placeholder = /** @type {(inputs: Cap_Select_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select your licence`)
};

/**
* | output |
* | --- |
* | "Select your licence" |
*
* @param {Cap_Select_PlaceholderInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_select_placeholder = /** @type {((inputs?: Cap_Select_PlaceholderInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Select_PlaceholderInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_select_placeholder(inputs)
	if (locale === "en") return en_cap_select_placeholder(inputs)
	return es_cap_select_placeholder(inputs)
});